<template>
	<form @submit.prevent="validate(form_scope)" :data-vv-scope="form_scope" class="login-form">

		<h3 class="text-center mb-4">
			Anmelden
		</h3>
		<div class="row">
			<div class="col-12 form-group">
<!--
				<label for="form-login" class="form-label">Login</label>
-->
				<input id="form-login"
						name="login"
						v-validate="'required'"
						:disabled="isLoading"
						type="text"
						:class="vee(form_scope+'.login').classes"
						class="form-control"
						placeholder="Benutzername"
						v-model="username"
				>
				<vee-message :path="form_scope+'.login'"></vee-message>
			</div>
		</div>
		<div class="row mb-4">
			<div class="col-12">
<!--
				<label for="form-password" class="form-label">Password</label>
-->
				<input id="form-password"
						name="password"
						v-validate="'required'"
						:disabled="isLoading"
						type="password"
						:class="vee(form_scope+'.password').classes"
						class="form-control"
						placeholder="Passwort"
						v-model="password">
				<vee-message :path="form_scope+'.password'"></vee-message>
			</div>
		</div>
		<form-message scope="postAuth"></form-message>
		<div class="row">
			<div class="col-12">
				<button type="submit" class=" btn btn-info">LOGIN</button>
			</div>
		</div>
	</form>
	
</template>

<script>

	import VeeMessage from '@/parts/vee-message';
	import FormMessage from '@/parts/form-message';

	export default {
		name: "login",
		components:{
			VeeMessage,
			FormMessage
		},
		data(){
			return{
				form_scope: 'postAuth',
				username: '',
				password: ''

			}
		},
		computed:{
			isLoading(){
				return this.isLoad(this.form_scope);
			},

		},
		mounted(){
			window.lg = this; //TODO: remove after development ends
		},

		methods:{

			validate(scope){


				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						this.postAuth();

					}
				});
			},

			postAuth(){

				this.$store.dispatch('postAuth', {
					username: this.username,
					password: this.password,
					scope: 'postAuth'
				}).then((response)=>{
					console.log(response)
				})
			}

		}
	}
</script>

<style scoped>

</style>